/*
  Auto-bundle: keeps the free-gift lines in lockstep with the trigger products.
  Each companion (gift) line's quantity is synced to the total quantity of the
  trigger lines that entitle it — add a mask, the gifts appear; raise the mask
  to qty 2, the gifts follow (the BXGY discounts have no per-order use limit,
  so every trigger unit qualifies and Shopify never splits the trigger line);
  remove the last trigger and the gifts leave with it.

  Entitlements: LUYORS_AUTOBUNDLE.companionExclusions maps a trigger VARIANT id
  to companion variant ids it does NOT entitle (the mask's "Neck & Chest Only"
  variant excludes the eye protectors). A companion's desired quantity is the
  sum of quantities of entitling trigger lines.

  Wraps window.fetch once so all add/change/update code paths in this theme
  are covered by a single hook. One /cart/update.js call fixes every drifted
  companion quantity at once (update.js adds lines that aren't in the cart yet).

  Perf:
   - Non-cart fetches: regex test + early return (~0 cost).
   - Cart mutations already in sync: regex test + one JSON parse + one /cart.js.
   - Drifted: +1 /cart/update.js + 1 DOM swap.

  Recursion guard: our own sync POSTs are tagged with the X-Luyors-Companion: 1
  header; the wrapper short-circuits on requests carrying that header.

  Concurrency guard: inFlight prevents overlapping syncs; a mutation observed
  while one is running is caught by the NEXT mutation's reconcile (every
  reconcile works from fresh /cart.js state, so drift never sticks).

  Deliberate: gift lines have no remove control in the theme (exact-quantity
  BXGY — a deleted gift would un-free the rest), so there is no "customer
  removed this gift" memory. A standalone paid purchase of a gift product
  with no trigger in cart is left alone only until the next reconcile; these
  products are unlisted, so that path is effectively unreachable.
*/
(function () {
  if (!window.LUYORS_AUTOBUNDLE) return;
  /* GIFT SETS: [{triggers: [product_ids], companions: [variant_ids],
     exclusions: {trigger_variant_id: [companion_variant_ids]}}, ...].
     Equinox, Belt and Panel each have a set (each backed by its own BXGY).
     Legacy single-set keys are synthesized into a set for cached pages. */
  var SETS = window.LUYORS_AUTOBUNDLE.giftSets;
  if (!Array.isArray(SETS) || !SETS.length) {
    var legacyTriggers = window.LUYORS_AUTOBUNDLE.triggerProductIds;
    if (!Array.isArray(legacyTriggers)) {
      legacyTriggers = window.LUYORS_AUTOBUNDLE.triggerProductId
        ? [window.LUYORS_AUTOBUNDLE.triggerProductId]
        : [];
    }
    var legacyCompanions = window.LUYORS_AUTOBUNDLE.companionVariantIds;
    if (!Array.isArray(legacyCompanions) || !legacyCompanions.length) {
      legacyCompanions = window.LUYORS_AUTOBUNDLE.companionVariantId
        ? [window.LUYORS_AUTOBUNDLE.companionVariantId]
        : [];
    }
    SETS = [{
      triggers: legacyTriggers,
      companions: legacyCompanions,
      exclusions: window.LUYORS_AUTOBUNDLE.companionExclusions || {}
    }];
  }
  SETS = SETS.filter(function (s) {
    return s && Array.isArray(s.triggers) && s.triggers.length &&
      Array.isArray(s.companions) && s.companions.length;
  });
  if (!SETS.length) return;

  /* Unions used for fast membership tests. */
  var TRIGGERS = [];
  var COMPANIONS = [];
  var TRIGGER_VARIANTS = [];
  SETS.forEach(function (s) {
    s.triggers.forEach(function (pid) {
      if (TRIGGERS.indexOf(pid) === -1) TRIGGERS.push(pid);
    });
    s.companions.forEach(function (vid) {
      if (COMPANIONS.indexOf(vid) === -1) COMPANIONS.push(vid);
    });
    (s.triggerVariants || []).forEach(function (vid) {
      if (TRIGGER_VARIANTS.indexOf(vid) === -1) TRIGGER_VARIANTS.push(vid);
    });
  });

  var HEADER = 'X-Luyors-Companion';
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/i;
  var MUTATE_RE = /\/cart\/(add|change|update)(\.js)?(\?|$)/i;
  var origFetch = window.fetch.bind(window);
  var inFlight = false;

  /* companion variant id -> quantity the cart's triggers entitle, summed
     across gift sets (the shared 2-yr warranty accumulates from Equinox AND
     Belt sets, matching what the combinable BXGYs cover). Pass
     overrideKey/overrideQty to evaluate a hypothetical quantity change. */
  function desiredQuantities(cart, overrideKey, overrideQty) {
    var desired = {};
    COMPANIONS.forEach(function (vid) { desired[vid] = 0; });
    cart.items.forEach(function (it) {
      var q = (overrideKey !== undefined && it.key === overrideKey) ? overrideQty : it.quantity;
      SETS.forEach(function (s) {
        if (s.triggers.indexOf(it.product_id) === -1) return;
        var excluded = (s.exclusions || {})[String(it.variant_id)] || [];
        s.companions.forEach(function (vid) {
          if (excluded.indexOf(vid) === -1) desired[vid] += q;
        });
      });
    });
    return desired;
  }

  function presentQuantity(cart, vid) {
    var have = 0;
    cart.items.forEach(function (it) {
      if (it.variant_id === vid) have += it.quantity;
    });
    return have;
  }

  /* companion variant id -> ADDITIONAL entitled quantity from items about to
     be added (matched by trigger VARIANT id, since pre-flight we only know
     variants, not products). */
  function entitledDeltas(addedItems) {
    var delta = {};
    addedItems.forEach(function (it) {
      SETS.forEach(function (s) {
        var tvs = s.triggerVariants || [];
        var isTrigger = tvs.some(function (tv) { return String(tv) === String(it.id); });
        if (!isTrigger) return;
        var excluded = (s.exclusions || {})[String(it.id)] || [];
        s.companions.forEach(function (vid) {
          if (excluded.indexOf(vid) === -1) delta[vid] = (delta[vid] || 0) + it.quantity;
        });
      });
    });
    return delta;
  }

  /* Parse an /cart/add.js request body into normalized items + passthrough
     fields. Returns null for shapes we don't rewrite (line properties,
     unparseable bodies) — those fall back to passthrough + reconcile. */
  function parseAddBody(body) {
    if (typeof body === 'string') {
      var obj;
      try { obj = JSON.parse(body); } catch (e) { return null; }
      var items = Array.isArray(obj.items)
        ? obj.items
        : (obj.id !== undefined ? [obj] : null);
      if (!items || !items.length) return null;
      var norm = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].properties) return null;
        var q = parseInt(items[i].quantity, 10);
        norm.push({ id: Number(items[i].id), quantity: isNaN(q) || q < 1 ? 1 : q });
      }
      return { items: norm, sections: obj.sections, sections_url: obj.sections_url };
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var id = body.get('id');
      if (!id) return null;
      var hasProps = false;
      body.forEach(function (v, k) { if (k.indexOf('properties') === 0) hasProps = true; });
      if (hasProps) return null;
      var fq = parseInt(body.get('quantity'), 10);
      return {
        items: [{ id: Number(id), quantity: isNaN(fq) || fq < 1 ? 1 : fq }],
        sections: body.get('sections'),
        sections_url: body.get('sections_url')
      };
    }
    return null;
  }

  window.fetch = function (input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (!MUTATE_RE.test(url)) return origFetch(input, init);

    var hdrs = init.headers || {};
    var isCompanion =
      hdrs[HEADER] || hdrs[HEADER.toLowerCase()] ||
      (typeof hdrs.get === 'function' && hdrs.get(HEADER));
    if (isCompanion) return origFetch(input, init);

    var isAdd = ADD_RE.test(url);
    var isChange = /\/cart\/change(\.js)?(\?|$)/i.test(url);

    /* ATOMIC ADD REWRITE: when a trigger (device) is being added, re-send as
       ONE JSON /cart/add.js with the gift lines FIRST and the device LAST.
       Shopify lists cart items newest-first, so the device ends up ABOVE its
       gifts in the cart AND at checkout (which mirrors true cart order), and
       the discount engine sees one atomic cart state. Unrewritable shapes
       (line properties, unknown bodies) fall through to passthrough + the
       post-response reconcile, which still adds gifts (just above the device). */
    if (isAdd && TRIGGER_VARIANTS.length) {
      var addBody = parseAddBody(init.body);
      var hasTriggerItem = addBody && addBody.items.some(function (it) {
        return TRIGGER_VARIANTS.some(function (tv) { return String(tv) === String(it.id); });
      });
      if (hasTriggerItem) {
        return origFetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var desired = desiredQuantities(cart);
            var deltas = entitledDeltas(addBody.items);
            var giftItems = [];
            COMPANIONS.forEach(function (vid) {
              var target = (desired[vid] || 0) + (deltas[vid] || 0);
              var addQty = target - presentQuantity(cart, vid);
              if (addQty > 0) giftItems.push({ id: vid, quantity: addQty });
            });
            if (!giftItems.length) return null; /* nothing to batch — passthrough */

            var headers = { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' };
            headers[HEADER] = '1';
            return origFetch('/cart/add.js', {
              method: 'POST',
              headers: headers,
              credentials: 'same-origin',
              body: JSON.stringify({
                items: giftItems.concat(addBody.items),
                sections: addBody.sections,
                sections_url: addBody.sections_url
              })
            });
          })
          .then(function (response) {
            if (response) return response;
            return observedPassthrough(input, init, isAdd);
          })
          .catch(function (e) {
            console.error('[auto-bundle]', e);
            return observedPassthrough(input, init, isAdd);
          });
      }
    }

    /* ATOMIC REWRITE: a quantity change on a trigger line is re-sent as ONE
       /cart/update.js carrying the trigger's new quantity AND the scaled gift
       quantities. The discount engine never sees the mismatched intermediate
       cart, so the transient qualifying/non-qualifying line split (visible as
       a flash of two mask lines) cannot occur. Anything unparseable falls
       through to the normal passthrough + post-response reconcile. */
    if (isChange && typeof init.body === 'string') {
      var changeBody = null;
      try { changeBody = JSON.parse(init.body); } catch (e) { /* form-encoded — passthrough */ }
      if (changeBody && changeBody.quantity !== undefined &&
          (changeBody.id !== undefined || changeBody.line !== undefined)) {
        return origFetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var target = null;
            cart.items.forEach(function (it, idx) {
              if (target) return;
              if (changeBody.id !== undefined) {
                if (it.key === changeBody.id || String(it.variant_id) === String(changeBody.id)) target = it;
              } else if (idx + 1 === Number(changeBody.line)) {
                target = it;
              }
            });
            /* Rewrite only for a trigger line whose variant maps to exactly one
               line — variant-keyed updates would merge duplicates otherwise. */
            var sameVariantLines = target ? cart.items.filter(function (it) {
              return it.variant_id === target.variant_id;
            }).length : 0;
            if (!target || TRIGGERS.indexOf(target.product_id) === -1 || sameVariantLines !== 1) {
              return null; /* signal passthrough */
            }
            var newQty = parseInt(changeBody.quantity, 10);
            if (isNaN(newQty) || newQty < 0) return null;

            var desired = desiredQuantities(cart, target.key, newQty);
            var updates = {};
            updates[target.variant_id] = newQty;
            COMPANIONS.forEach(function (vid) {
              if (presentQuantity(cart, vid) !== desired[vid]) updates[vid] = desired[vid];
            });

            var headers = { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' };
            headers[HEADER] = '1';
            return origFetch('/cart/update.js', {
              method: 'POST',
              headers: headers,
              credentials: 'same-origin',
              body: JSON.stringify({
                updates: updates,
                sections: changeBody.sections,
                sections_url: changeBody.sections_url
              })
            });
          })
          .then(function (response) {
            /* update.js returns the same cart-JSON (+ requested sections) shape
               the change.js caller expects, so it renders normally. */
            if (response) return response;
            return observedPassthrough(input, init, isAdd);
          })
          .catch(function (e) {
            console.error('[auto-bundle]', e);
            return observedPassthrough(input, init, isAdd);
          });
      }
    }

    return observedPassthrough(input, init, isAdd);
  };

  function observedPassthrough(input, init, isAdd) {
    return origFetch(input, init).then(function (response) {
      response.clone().json().then(function () {
        if (inFlight) return;
        inFlight = true;

        origFetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var desired = desiredQuantities(cart);
            var updates = {};
            var drift = false;
            COMPANIONS.forEach(function (vid) {
              var have = 0;
              cart.items.forEach(function (it) {
                if (it.variant_id === vid) have += it.quantity;
              });
              if (have !== desired[vid]) {
                updates[vid] = desired[vid];
                drift = true;
              }
            });
            if (!drift) return;
            return syncCompanions(updates, isAdd);
          })
          .catch(function (e) { console.error('[auto-bundle]', e); })
          .finally(function () { inFlight = false; });
      }).catch(function () { /* non-JSON response — ignore */ });
      return response;
    });
  }

  function syncCompanions(updates, openDrawer) {
    var headers = { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' };
    headers[HEADER] = '1';
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        updates: updates,
        sections: 'cart-drawer,cart-bubble',
        sections_url: window.location.pathname
      }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        renderCartSections(state, { keepClosed: !openDrawer });
        /* The /cart page renders its own section — refresh it so gift rows
           appear/adjust without a manual reload. */
        if (document.getElementById('Cart')) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      });
  }

  function renderCartSections(state, opts) {
    if (!state || !state.sections) return;
    [
      { id: 'Cart-Drawer', selector: '.cart-drawer', section: 'cart-drawer' },
      { id: 'cart-drawer-toggle', selector: '.thb-item-count', section: 'cart-bubble' }
    ].forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = state.sections[s.section];
      if (!host || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sourceNode = doc.querySelector(s.selector);
      if (!sourceNode) return;
      var target = host.querySelector(s.selector) || host;
      target.innerHTML = sourceNode.innerHTML;
    });

    /* Re-init drawer behaviors after innerHTML swap. Mirrors the
       theme's ProductCard.renderContents pattern at app.js:233-245 —
       without this, the drawer loses its scroll/drag bindings and
       the header icon bar de-syncs. */
    if (typeof CartDrawer !== 'undefined') {
      try { new CartDrawer(); } catch (e) { /* re-init is best-effort */ }
    }
    if (typeof initiateFlicktyInDrawer === 'function') {
      try { initiateFlicktyInDrawer(); } catch (e) {}
    }
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.open === 'function' && !(opts && opts.keepClosed)) {
      drawer.open();
    }
  }

  /* Back/forward navigations can render a page snapshot from BEFORE a cart
     mutation: Chrome serves history navigations from HTTP cache (pageshow
     persisted=false, navigation type "back_forward"), so the server-rendered
     badge and drawer show the old cart — 0 items after an add — while
     /cart.js holds the truth. cart:refresh makes the theme re-fetch its cart
     sections from the server (CartDrawer.refresh in app.js, Cart.refresh in
     cart.js). cart.js only registers its listener at window load, so wait
     for load on the initial pass; bfcache restores (pageshow persisted) land
     on an already-loaded document and dispatch immediately. */
  function refreshStaleCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  var navEntry = (window.performance && performance.getEntriesByType)
    ? performance.getEntriesByType('navigation')[0]
    : null;
  if (navEntry && navEntry.type === 'back_forward') {
    if (document.readyState === 'complete') {
      refreshStaleCartUI();
    } else {
      window.addEventListener('load', refreshStaleCartUI, { once: true });
    }
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshStaleCartUI();
  });
})();
